function convert_html_attributes(attrs) {
  if (!attrs)
    return {};
  const result = {};
  const add_attr = (key, value) => {
    if (value !== null && value !== void 0) {
      if (typeof value === "boolean") {
        result[key] = value ? "true" : "false";
      } else {
        result[key] = String(value);
      }
    }
  };
  for (const [key, value] of Object.entries(attrs)) {
    const html_key = key.replace(/_/g, "-");
    add_attr(html_key, value);
  }
  return result;
}
export {
  convert_html_attributes as c
};
